import {FuseNavigation} from '@fuse/types';

/** Shows the toolbar Track Order button to customer logins. Off unless the role turns it on. */
export const CUSTOMER_TRACK_ORDER_FEATURE = 'customer-track-order';

/** Shows "Add Customer Paperwork" on the Daily Manifest row actions to customer logins. Off unless the role turns it on. */
export const CUSTOMER_ADD_PAPERWORK_FEATURE = 'customer-add-paperwork';

/** Shows the "add POD" button on the order view to customer logins. Off unless the role turns it on. */
export const CUSTOMER_ADD_POD_FEATURE = 'customer-add-pod';

/** Open each client portal Dashboard panel by default for customer logins. Off unless the role turns it on; a customer's own Display Panel choice wins. */
export const CUSTOMER_DASHBOARD_ORDERS_THIS_WEEK_FEATURE = 'customer-dashboard-orders-this-week';
export const CUSTOMER_DASHBOARD_UNBILLED_ORDERS_FEATURE = 'customer-dashboard-unbilled-orders';
export const CUSTOMER_DASHBOARD_SALES_REVENUE_FEATURE = 'customer-dashboard-sales-revenue';
export const CUSTOMER_DASHBOARD_OUTSTANDING_PODS_FEATURE = 'customer-dashboard-outstanding-pods';

export const customerFeature: FuseNavigation[] = [
    {
        id: 'features',
        title: 'Features',
        type: 'group',
        children: [
            {
                id: CUSTOMER_TRACK_ORDER_FEATURE,
                title: 'Track Order (toolbar)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_ADD_PAPERWORK_FEATURE,
                title: 'Add Customer Paperwork (Daily Manifest)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_ADD_POD_FEATURE,
                title: 'Add POD (Order View)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_DASHBOARD_ORDERS_THIS_WEEK_FEATURE,
                title: 'Show Orders For This Week (Dashboard)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_DASHBOARD_UNBILLED_ORDERS_FEATURE,
                title: 'Show Unbilled Orders (Dashboard)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_DASHBOARD_SALES_REVENUE_FEATURE,
                title: 'Show Sales Revenue (Dashboard)',
                type: 'item',
                children: []
            },
            {
                id: CUSTOMER_DASHBOARD_OUTSTANDING_PODS_FEATURE,
                title: 'Show Outstanding PODs (Dashboard)',
                type: 'item',
                children: []
            }
        ]
    }
];
